import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";
import ErrorComp from "../common/errorComp";
// import HomePage from './homePage';
import MainLayout from "../common/layout";
import WithAuthenticator from "../withAuthenticator";
import { FormStoreW } from './doctorAdmin/masterManagement/context-reducers/context-reducer';
// import GuardedRoute from './guardedRoute'
import { CreateOrdersets, ManageOrdersets } from './orderSets'


function retry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}

// const HomePage = lazy(() => retry(()=> import("./homePage")));

const OrgRegistration = lazy(() =>  retry(()=> import("./org/orgRegistration")));
const ListOrg = lazy(() =>  retry(()=> import("./org/listOrg")));

const CreateTemplateComp = lazy(()=> retry(()=>  import("./doctorAdmin/masterManagement/templateMaster/formNew/createTemplate"))) ;
const ManageTemplateComp = lazy(()=> retry(()=>  import("./doctorAdmin/masterManagement/templateMaster/manageTemplates"))) ;
const CreateQuestionComp = lazy(()=> retry(()=> import("./doctorAdmin/masterManagement/templateMaster/createQuestions"))) ;
const TrackQuestionsComp = lazy(()=> retry(()=> import("./doctorAdmin/masterManagement/templateMaster/trackQuestions"))) ;
const ManageSubTemplates = lazy(()=>retry(()=>import("./doctorAdmin/masterManagement/templateMaster/formNew/subTemplates/index")));

const SaveForm = lazy(()=> retry(()=> import("./doctorAdmin/masterManagement/templateMaster/saveForm"))) ;
const SaveForm2 = lazy(()=> retry(()=> import("./doctorAdmin/masterManagement/templateMaster/saveForm2"))) ;
const ManageUnits = lazy(()=> retry(()=> import("./units/manageUnits")));
const EditUnit = lazy(()=> retry(()=> import("./units/editUnitInfo")));
const UnitRegistrationForm = lazy(()=> retry(()=> import("./units/unitRegistration"))) ;
const ManageDevices = lazy(() => retry(()=> import('./devices/manageDevices')));
const AddDevices = lazy(() => retry(()=> import('./devices/addDevice')));
const ManageTests = lazy(() => retry(()=> import('./devices/manageTests')));
const SubmitForm = lazy(() => retry(()=> import('./doctorAdmin/submitForm')));
// const SearchForm = lazy(() => import('./doctorAdmin/searchForm'));
const EditDevice = lazy(() =>  retry(()=> import("./devices/editDevices")));
const GlobalDeviceManage =lazy(() =>  retry(()=> import("./devices/globalDevices")));
const PreviewDemo =lazy(() =>  retry(()=> import("./doctorAdmin/masterManagement/templateMaster/formNew/preview")));
const CreateSubscriber = lazy(() =>  retry(()=> import("./subscriber/subscriberRegistration")));
const EditSubscriber = lazy(() =>  retry(()=> import("./subscriber/editSubscriber")));
const SubcriberList = lazy(() =>  retry(()=> import("./subscriber/subscriberList")));
const CreateStaff = lazy(() =>  retry(()=> import("./staff/staffRegistration")));
const AssignForms = lazy(() =>  retry(()=> import("./subscriber/assignForms")));
const SubscriberSettings = lazy(() =>  retry(()=> import("./subscriber/settings")));
const Notifications = lazy(() =>  retry(()=> import("./doctorAdmin/masterManagement/templateMaster/formNew/notifications")));

const ViewForm = lazy(() =>  retry(()=> import('../../openApi/viewForm')));
const SubmitFormOpen = lazy(() =>  retry(()=> import('../../openApi/submitFormRest')));
const Preview =lazy(() =>  retry(()=> import("../../openApi/preview")));

const ManageInventory =lazy(() => retry(()=> import("./inventory/manageInventory.js")));
const SearchDevice =lazy(() =>  retry(()=> import("./inventory/searchDevice.js")));
const ManageConfigurations =lazy(() =>  retry(()=> import("./inventory/manageConfigurations.js")));

const EditTemplateComp = lazy(()=>  retry(()=> import("./doctorAdmin/masterManagement/templateMaster/formNew/editTemplate")));



const Routes = props => {
  return (
    <Router>
        <ErrorComp>
            <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                    {/*<Route exact path="/" render={()=>(<OrgRegistration/>)}/> */}
                    
                   <Route exact path="/" render={()=>{
                        if(props.permissions.indexOf('Admin') != -1){
                            return(<ListOrg/>)
                        }else if(props.permissions.indexOf('FormEngineOperator') != -1 || props.permissions.indexOf('FormSubscriber') != -1){
                            return(<FormStoreW><ManageTemplateComp/></FormStoreW>)
                        }else{
                            return (<MainLayout>
                                <p>Not Authenticated</p>
                              </MainLayout>)
                        }
                    }}/> 

                    
                    <Route exact path="/createOrganization" render={()=>(<OrgRegistration/>)}/>
                    <Route exact path="/orgList" render={()=>(<ListOrg/>)}/>
                    <Route exact path="/manageUnits" render={()=>(<ManageUnits/>)}/>
                    <Route exact path="/editUnit" render={()=>(<EditUnit/>)}/>
                    <Route exact path="/createUnit" render={()=>(<UnitRegistrationForm/>)}/> 
                    {/* <Route exact path="/createSection" render={()=>(<CreateSectionComp />)}/> */}
                    {/* <Route exact path="/manageSection" render={()=>(<ManageSection />)}/> */}

                    <Route exact path="/createTemplate" render={()=>(<FormStoreW><CreateTemplateComp /></FormStoreW>)}/>
                    <Route exact path="/editTemplate" render={()=>(<FormStoreW><EditTemplateComp /></FormStoreW>)}/>

                    <Route exact path="/manageForms" render={()=>(<FormStoreW><ManageTemplateComp /></FormStoreW>)}/>
                    <Route exact path="/notifications" render={()=>(<FormStoreW><Notifications /></FormStoreW>)}/>
                    <Route exact path="/createQuestion" render={()=>(<FormStoreW><CreateQuestionComp /></FormStoreW>)}/>
                    <Route exact path="/trackQuestions" render={()=>(<FormStoreW><TrackQuestionsComp /></FormStoreW>)}/>
                    <Route exact path="/manageSubTemplates" render={()=>(<FormStoreW><ManageSubTemplates /></FormStoreW>)}/>

                    <Route exact path="/saveForm" render={()=>(<SaveForm />)}/>
                    <Route exact path="/chat" render={()=>(<SaveForm2 />)}/>
                    <Route exact path="/viewForm" render={()=>(<ViewForm />)}/>
                    <Route exact path="/previewDemo/:id?" render={() => <PreviewDemo />} />
                    <Route exact path="/submitForm2" render={()=>(<FormStoreW><SubmitForm /></FormStoreW>)}/>
                    {/* <Route exact path="/searchForm2" render={()=>(<SearchForm />)}/> */}
                    <Route exact path="/submitForm" render={()=>(<SubmitFormOpen />)}/>
                    <Route exact path="/preview" render={() => <Preview />} />

                    <Route exact path="/createUnit" render={()=>(<UnitRegistrationForm/>)}/>
                    <Route exact path="/manageUnits" render={()=>(<ManageUnits/>)}/>
                    <Route exact path="/manageDevices" render={()=>(<ManageDevices/>)}/>
                    <Route exact path="/addDevice" render={()=>(<AddDevices/>)}/>
                    <Route exact path="/manageTests" render={()=>(<ManageTests/>)}/>
                    <Route exact path="/editDevice" render={() => <EditDevice />} />
                    <Route exact path="/globalDeviceManage" render={() => <GlobalDeviceManage />} />
                    <Route exact path="/createSubscriber" render={() => <CreateSubscriber/>} />
                    <Route exact path="/editSubscriber" render={() => <EditSubscriber/>} />
                    <Route exact path="/manageSubscriber" render={() => <SubcriberList/>} />
                    <Route exact path="/assignForms" render={() => <FormStoreW><AssignForms/></FormStoreW>} />
                    <Route exact path="/settings" render={() => <SubscriberSettings/>} />

                    <Route exact path="/searchDevice" render={() => <SearchDevice/>} />
                    <Route exact path="/manageInventory" render={() => <ManageInventory/>} />
                    <Route exact path="/manageConfigurations" render={() => <ManageConfigurations/>} />

                    <Route exact path="/manageOrdersets" render={() => <ManageOrdersets/>} />
                    <Route exact path="/createOrdersets" render={() => <CreateOrdersets/>} />

                    <Route exact path="/createStaff" render={() => <CreateStaff/>} />

                    <Route render={() => <ErrorComp role={props.role} />} />
          </Switch>
        </Suspense>
      </ErrorComp>
    </Router>
  );
};

export default WithAuthenticator(Routes);
